export default {"src":"/_next/static/media/file-text.54997adf.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};